/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown> }} Automation_Trigger_Task_AssignedInputs */

const en_automation_trigger_task_assigned = /** @type {(inputs: Automation_Trigger_Task_AssignedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} assigned`)
};

const pt_br2_automation_trigger_task_assigned = /** @type {(inputs: Automation_Trigger_Task_AssignedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} atribuída`)
};

/**
* | output |
* | --- |
* | "{task} assigned" |
*
* @param {Automation_Trigger_Task_AssignedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_trigger_task_assigned = /** @type {((inputs: Automation_Trigger_Task_AssignedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Trigger_Task_AssignedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_trigger_task_assigned(inputs)
	return pt_br2_automation_trigger_task_assigned(inputs)
});